import { useConditionFieldSelect } from '../../hooks/useConditionFieldSelect';
import { useEditorActions } from '../../hooks/useEditorActions';
import EditorConditionFieldOptions from './EditorConditionFieldOptions';
import EditorFilterSelectBreadcrumbs from './EditorFilterSelectBreadcrumbs';
import EditorTitle from './EditorTitle';
import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { PopoverCloseButton } from 'foundations-components/transitional/components/Popover';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionFieldSelectPanelContainer = styled.div.withConfig({
  displayName: "EditorConditionFieldSelectPanel__EditorConditionFieldSelectPanelContainer",
  componentId: "sc-1a57lrj-0"
})(["display:flex;flex-direction:column;height:100%;width:400px;"]);
const EditorConditionFieldSelectPanel = ({
  filterFamily
}) => {
  const {
    filterFamilyName,
    inputRef,
    isLoadingFields,
    onSearchChange,
    searchString
  } = useConditionFieldSelect(filterFamily);
  const {
    onConditionSelectCancel
  } = useEditorActions();
  return /*#__PURE__*/_jsxs(EditorConditionFieldSelectPanelContainer, {
    children: [/*#__PURE__*/_jsxs(View, {
      padding: "400",
      as: "div",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(EditorTitle, {}), /*#__PURE__*/_jsx(PopoverCloseButton, {
          onClick: onConditionSelectCancel
        })]
      }), /*#__PURE__*/_jsx(EditorFilterSelectBreadcrumbs, {}), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(SearchInput, {
          "data-onboarding": "search-properties-input-field",
          "data-selenium-test": "fr-filter-search-input",
          inputRef: inputRef,
          onChange: onSearchChange,
          placeholder: I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputPlaceholder', {
            filterFamilyLabel: filterFamilyName.toLowerCase()
          })
        })
      })]
    }), /*#__PURE__*/_jsx(EditorConditionFieldOptions, {
      filterFamily: filterFamily,
      isLoadingFields: isLoadingFields,
      searchString: searchString
    })]
  });
};
export default EditorConditionFieldSelectPanel;